export default {
  GET_ADMIN_NOTIFICATIONS_REQUEST: "GET_ADMIN_NOTIFICATIONS_REQUEST",
  GET_ADMIN_NOTIFICATIONS_SUCCESS: "GET_ADMIN_NOTIFICATIONS_SUCCESS",
  GET_ADMIN_NOTIFICATIONS_FAIL: "GET_ADMIN_NOTIFICATIONS_FAIL",

  ADD_ADMIN_NOTIFICATIONS_LOADING: "ADD_ADMIN_NOTIFICATIONS_LOADING",
};

